import type { Environment } from "@fas/cpa-state-manager/services/auth";
import getEndpoints from "./endpoints";

const baseUrl = "https://api.smartlink.adsempire.com";
const env: Environment = getEndpoints({
  baseUrl,
  reCaptchaKey: "6Lf-NOIeAAAAAI1MzsYU2nIQGzq300SFFhw55Q-Z",
});
export default env;
